import { useState, useEffect } from "react";
import {
    MFAContainer
} from "../styled";
import {Button, Form, Header} from "semantic-ui-react";
import {CustomDivider, CustomGrid} from "../../components/custom-common";

const ValidateChangeMFA = ({removeMethod, validateMfaCodeError, loading}) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState(validateMfaCodeError)
    const [disableBtn, setDisableBtn] = useState(true);

    const handleChange = (e) => {
        if (e.target.value.length > 0) {
          setDisableBtn(false);
          setError(null)
        } else {
          setDisableBtn(true)
        };
        setPassword(e.target.value)
    }

    useEffect(() => {
      setError(validateMfaCodeError);
    }, [validateMfaCodeError])

    return (
      <MFAContainer
        maxWidth={"456px"}
        className="mfaPasswordPage"
      >
        <Header as="h2" textAlign="center">
          Enter password
        </Header>
        <CustomDivider small hidden/>
        <CustomGrid>
          <CustomGrid.Row columns={2}>
            <CustomGrid.Column width={12}>
              <MFAContainer className="verifyMethodChange" maxWidth={"308px"}>
                <div className={'small'}>
                  Enter your password to change your two-factor authentication method—
                </div>
                <CustomDivider small hidden/>
                <Form>
                  <Form.Field className={"contentLeft"} error={!!error}>
                      <Form.Input
                        label={"Password"}
                        type="password"
                        name={"changeMFAMethod"}
                        id={"changeMFAMethod"}
                        onChange={(e) => handleChange(e)}
                        value={password}
                        required
                        disabled={loading}
                        error={!!error}
                        className={"verifyInput noVerticalMargin"}
                      />
                      {error && (
                        <span className={'warningRedText smaller'}>{error}</span>
                      )}
                  </Form.Field>
                </Form>
                <CustomDivider small hidden/>
                <Button primary
                    loading={loading}
                    disabled={loading || disableBtn}
                    onClick={() => {
                        removeMethod(password)
                    }}
                >
                  Submit
                </Button>
              </MFAContainer>
            </CustomGrid.Column>
          </CustomGrid.Row>
        </CustomGrid>
      </MFAContainer>
    );
}

export default ValidateChangeMFA
